<template>
  <div>
    <Header :navTitle="title" :navPath="`/mobile/course/detail/${cur_uuid}`" :hasRightContent="true" :rightHandler="rightHandler">
      <template #navRightContent>
        <span>重新做题</span>
      </template>
    </Header>
    <van-tabs
      v-model:active="activeName"
      color="#009dd9"
      title-active-color="#00ADEF"
      line-width="60"
      @change="initErrorPage"
      class="tab_common exercise_tabs">
      <van-tab title="全部" name="total">
        <div class="show_frame" id="showFrame" v-if="activeName === 'total'">
          <div :class="{'exercise_wrap':true, 'clearfix':true, 'no_trans': isNoTrans }"
            :style="{'width': `${screenWidth * loadedQuestions.length}px`}"
            id="exerciseWrap">
            <!-- 判断题 -->
            <div class="container" v-for="(item, index) in judgeChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt><span>一、判断题</span></dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.judgeNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                            <!-- 判断题 -->
                            <van-radio-group v-model="item.selected" @change="onSubmit(item)" :disabled="item.user_answer !== null">
                              <van-radio name="1">
                                <div class="opts_wrap">
                                  <div class="opts_content"><p>对</p></div>
                                </div>
                              </van-radio>
                              <van-radio name="0">
                                <div class="opts_wrap">
                                  <div class="opts_content"><p>错</p></div>
                                </div>
                              </van-radio>
                            </van-radio-group>
                          </div>
                          <div class="analysis" v-if="item.user_answer">
                            <div class="answer">
                              <span class="error" v-if="item.user_answer.is_right === false"><van-icon name="cross" />回答错误</span>
                              <span class="success" v-if="item.user_answer.is_right === true"><van-icon name="success" />回答正确</span>
                              <span>正确答案：{{ JSON.parse(item.answer)[0] == 1 ? '对' : '错' }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- 单选题 -->
            <div class="container" v-for="(item, index) in singleChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt>
                    <span v-if="judgeObj.length > 0">二、单选题</span>
                    <span v-else>一、单选题</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.singleChoiceNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                            <!-- 单选题 -->
                            <van-radio-group v-model="item.selected" @change="onSubmit(item)" :disabled="item.user_answer !== null">
                              <van-radio v-for="option in item.options" :key="option.identification" :name="option.identification">
                                <div class="opts_wrap">
                                  <div class="opts_no">{{option.identification}}. </div>
                                  <div class="opts_content" v-html="option.option"></div>
                                </div>
                              </van-radio>
                            </van-radio-group>
                          </div>
                          <div class="analysis" v-if="item.user_answer">
                            <div class="answer">
                              <span class="error" v-if="item.user_answer.is_right === false"><van-icon name="cross" />回答错误</span>
                              <span class="success" v-if="item.user_answer.is_right === true"><van-icon name="success" />回答正确</span>
                              <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- 多选题 -->
            <div class="container" v-for="(item, index) in multipleChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt>
                    <span v-if="singleChoiceObj.length > 0 && judgeObj.length > 0">三、多选题</span>
                    <span v-else-if="singleChoiceObj.length > 0 || judgeObj.length > 0">二、多选题</span>
                    <span v-else>一、多选题</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.multiChoiceNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                              <van-checkbox-group v-model="item.selected" :disabled="item.user_answer !== null">
                                <van-checkbox shape="square" :name="option.identification" v-for="option in item.options" :key="option.identification">
                                  <div class="opts_wrap">
                                    <div class="opts_no">{{option.identification}}. </div>
                                    <div class="opts_content" v-html="option.option"></div>
                                  </div>
                                </van-checkbox>
                              </van-checkbox-group>
                          </div>
                          <div class="btn" style="margin-bottom:15px;">
                            <van-button type="primary" @click="onSubmit(item)">确定</van-button>
                          </div>
                          <div class="analysis" v-if="item.user_answer">
                            <div class="answer">
                              <span class="error" v-if="item.user_answer.is_right === false"><van-icon name="cross" />回答错误</span>
                              <span class="success" v-if="item.user_answer.is_right === true"><van-icon name="success" />回答正确</span>
                              <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="错题集" name="wrong">
        <div class="show_frame" id="errorShowFrame" v-if="activeName === 'wrong' && totalErrorQuestionNos.length > 0">
          <div :class="{'exercise_wrap':true, 'clearfix':true, 'no_trans': isNoTrans }"
               :style="{'width': `${screenWidth * errorContainerNum * loadedErrorQuestions.length}px`}"
               id="errorExerciseWrap">
            <!-- 判断题 -->
            <div class="container" v-for="(item, index) in errorJudgeChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt><span>一、判断题</span></dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.errorJudgeNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                            <!-- 单选题 -->
                            <van-radio-group v-model="item.selected" :disabled="true">
                              <van-radio name="1" key="1">
                                <div class="opts_wrap">
                                  <div class="opts_content"><p>对</p></div>
                                </div>
                              </van-radio>
                              <van-radio name="0" key="0">
                                <div class="opts_wrap">
                                  <div class="opts_content"><p>错</p></div>
                                </div>
                              </van-radio>
                            </van-radio-group>
                          </div>
                          <div class="analysis">
                            <div class="answer">
                              <span class="error"><van-icon name="cross" />回答错误</span>
                              <span>正确答案：{{ JSON.parse(item.answer)[0] == 1 ? '对' : '错' }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- 单选题 -->
            <div class="container" v-for="(item, index) in errorSingleChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt>
                    <span v-if="judgeObj.length > 0">二、单选题</span>
                    <span v-else>一、单选题</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.errorSingleChoiceNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                            <!-- 单选题 -->
                            <van-radio-group v-model="item.selected" :disabled="true">
                              <van-radio v-for="option in item.options" :key="option.identification" :name="option.identification">
                                <div class="opts_wrap">
                                  <div class="opts_no">{{option.identification}}. </div>
                                  <div class="opts_content" v-html="option.option"></div>
                                </div>
                              </van-radio>
                            </van-radio-group>
                          </div>
                          <div class="analysis">
                            <div class="answer">
                              <span class="error"><van-icon name="cross" />回答错误</span>
                              <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
            <!-- 多选题 -->
            <div class="container" v-for="(item, index) in errorMultipleChoice" :key="item.id" :style="{'width': `${screenWidth}px`}">
              <div class="clearfix">
                <dl class="exercise ueditor_style">
                  <dt>
                    <span v-if="singleChoiceObj.length > 0 && judgeObj.length > 0">三、多选题</span>
                    <span v-else-if="singleChoiceObj.length > 0 || judgeObj.length > 0">二、多选题</span>
                    <span v-else>一、多选题</span>
                  </dt>
                  <dd>
                    <ul>
                      <li>
                        <div class="no">{{ questionNos.errorMultiChoiceNos[item.id] }}.</div>
                        <div class="content" >
                          <div class="stem" v-html="item.stem"></div>
                          <div class="options">
                              <van-checkbox-group v-model="item.selected" :disabled="true">
                                <van-checkbox shape="square" :name="option.identification" v-for="option in item.options" :key="option.identification">
                                  <div class="opts_wrap">
                                    <div class="opts_no">{{option.identification}}. </div>
                                    <div class="opts_content" v-html="option.option"></div>
                                  </div>
                                </van-checkbox>
                              </van-checkbox-group>
                          </div>
                          <div class="analysis">
                            <div class="answer">
                              <span class="error"><van-icon name="cross" />回答错误</span>
                              <span>正确答案：{{ JSON.parse(item.answer).join(',') }}</span>
                            </div>
                            <div class="tip" v-if="item.analysis">
                              <van-tag color="#e6f7fd" text-color="#00adef" size="medium">试题解析</van-tag>
                              <p v-html="item.analysis"></p>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无内容哦~"></van-empty>
      </van-tab>
    </van-tabs>
    <!-- 相关操作 -->
    <div :class="{'sheet_fixed_bottom': true, 'active': isShowList}">
      <div class="top">
        <div class="left">
          <span @click="tagQuestion">
            <i v-if="activeName === 'total'" :class="{ 'iconfont': true, 'icon-biaoqian1-01': true, 'active': isTagActive() }"></i>
            <i v-else :class="{ 'iconfont': true, 'icon-biaoqian1-01': true, 'active': isTagActiveError() }"></i>
            <span>标记</span></span>
        </div>
        <div class="right">
          <span @click="isShowList = !isShowList">
            <i class="iconfont icon-tubiaocankaoxian1024-03"></i>
            <span v-if="isShowList">收起列表</span>
            <span v-else>展开列表</span>
          </span>
        </div>
      </div>
      <div class="bottom" v-show="isShowList">
        <div class="container" v-show="activeName === 'total'">
          <div v-if="judgeObj.length > 0">
            <h4 class="title">一、判断题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of judgeObj">
                <div :title="item.id" :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div v-if="singleChoiceObj.length > 0">
            <h4 class="title" v-if="judgeObj.length > 0">二、单选题</h4>
            <h4 class="title" v-else>一、单选题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of singleChoiceObj">
                <div :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div v-if="multiChoiceObj.length > 0">
            <h4 class="title" v-if="judgeObj.length > 0 && singleChoiceObj.length > 0">三、多选题</h4>
            <h4 class="title" v-else-if="judgeObj.length > 0 || singleChoiceObj.length > 0">二、多选题</h4>
            <h4 class="title" v-else>一、多选题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of multiChoiceObj">
                <div :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="container" v-show="activeName === 'wrong'">
          <div v-if="errorJudgeObj.length > 0">
            <h4 class="title">一、判断题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of errorJudgeObj">
                <div :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorErrorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div v-if="errorSingleChoiceObj.length > 0">
            <h4 class="title" v-if="errorJudgeObj.length > 0">二、单选题</h4>
            <h4 class="title" v-else>一、单选题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of errorSingleChoiceObj">
                <div :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorErrorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div v-if="errorMultiChoiceObj.length > 0">
            <h4 class="title" v-if="errorJudgeObj.length > 0 && errorSingleChoiceObj.length > 0">三、多选题</h4>
            <h4 class="title" v-else-if="errorJudgeObj.length > 0 || errorSingleChoiceObj.length > 0">二、多选题</h4>
            <h4 class="title" v-else>一、多选题</h4>
            <van-row class="index_list">
              <van-col span="3" v-for="(item, index) of errorMultiChoiceObj">
                <div :class="{'index': true, 'success': item.is_right === true, 'error': item.is_right === false}" @click="anchorErrorLinkTo(item.id)">
                  <i class="iconfont icon-biaoqian1-01" v-if="userTags.indexOf(item.id) >= 0"></i>
                  {{ index + 1 }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <Overlay :isLoad="!loaded"></Overlay>
    <!-- 透明遮罩层 -->
    <Overlay :isLoad="!partLoaded" :zIndex="1" class="part_loading"></Overlay>
    <!-- 引导层 -->
    <van-overlay :show="showHelp" z-index="10" :custom-style="{'display': 'flex',
    'flex-direction': 'column','align-items': 'center','justify-content': 'center'}">
      <div class="help_wrap">
        <div class="title">左右滑动切换上一题，下一题</div>
        <img :src="require('assets/img/help_arrow.png')" class="arrow" />
        <img :src="require('assets/img/help_hand.png')" class="hand" />
        <button type="button" @click="showHelp = false">知道啦</button>
      </div>
    </van-overlay>
  </div>
</template>
<script>
  import Header from 'components/mobile/common/Header'
  import Overlay from 'components/mobile/common/Overlay'
  import { screenScrollHandler } from 'utils/mobile/common.js'
  import { get } from "api/course/course/create"
  import { initExercisePage } from "api/course/course/study"
  import { listPapaerQuestion } from "api/question/list"
  import { submitTest, addUserTag, clearPaperAnswer } from "api/question/list"
  import { checkUserCanStudy } from 'api/course/course/list'
  export default {
    components: {
      Header,
      Overlay
    },
    data() {
      return {
        isNoTrans: false,
        partLoaded: true,
        // isAlreadyLoadAllQuest: false,
        // isAlreadyLoadAllErrQuest: false,
        screenWidth: '',
        // screenHeight: '',
        containerNum: '',
        errorContainerNum: '',
        // showIndex: 0,
        // showFrameOffset: 0,
        activeQuestionId: '',
        showHelp: true,
        isMark: false,
        isShowList: false,
        loaded: false,
        cur_uuid: '',
        cur_name: '',
        paper_id: '',
        title: '',
        activeName: 'total',
        singleChoice: [],
        multipleChoice: [],
        judgeChoice: [],
        errorSingleChoice: [],
        errorMultipleChoice: [],
        errorJudgeChoice: [],
        singleChoiceObj: [],
        multiChoiceObj: [],
        judgeObj: [],
        errorSingleChoiceObj: [],
        errorMultiChoiceObj: [],
        errorJudgeObj: [],
        answeredQuestionIds: [],
        questionNos: {
          singleChoiceNos: {},
          multiChoiceNos: {},
          judgeNos: {},
          errorSingleChoiceNos: {},
          errorMultiChoiceNos: {},
          errorJudgeNos: {},
        },
        userTags: [],
        totalQuestionNos: [],
        loadedQuestions: [],
        selectQuestionIds: [],
        currentIndex: 0,
        totalErrorQuestionNos: [],
        currentErrorIndex: 0,
        loadedErrorQuestions: [],
        selectErrorQuestionIds: [],
      }
    },
    created() {
      if(localStorage.getItem('showQuestionHelp')){
        this.showHelp = false
      }
      else {
        localStorage.setItem('showQuestionHelp', true);
      }
      this.cur_uuid = this.$route.params.cur_uuid
      this.getCur()
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.$emit('update:isMainFullHeight', true);
      this.$emit('update:showFooter', false);
      this.screenWidth = document.body.clientWidth;
      // this.screenHeight = document.body.clientHeight;
      document.getElementsByTagName('body')[0].className = 'exercise_page'
      checkUserCanStudy({'cur_uuid': this.cur_uuid}).then(res => {
        if(!res.code) {
          this.$router.push(`/mobile/course/detail/${ this.cur_uuid }`)
        }
      })
    },
    unmounted () {
      document.body.removeAttribute('class')
      this.$emit('update:isMainFullHeight', false)
      this.$emit('update:showFooter', true)
    },
    methods: {
      rightHandler() {
        this.restart();
      },
      isTagActive() {
        if(this.loadedQuestions.length !== 0) {
          const currentId = this.loadedQuestions[this.currentIndex].id
          return this.userTags.indexOf(currentId) >= 0
        } else {
          return false
        }
      },
      isTagActiveError() {
        if(this.loadedErrorQuestions.length !== 0) {
          const currentId = this.loadedErrorQuestions[this.currentErrorIndex].id
          return this.userTags.indexOf(currentId) >= 0
        } else {
          return false
        }
      },
      getCur() {
        const that = this
        initExercisePage(this.cur_uuid).then(res => {
          if(res.code == 0){
            that.title = res.name
            that.singleChoiceObj = res.single_choices
            that.multiChoiceObj = res.multi_choices
            that.judgeObj = res.judge_list
            that.paper_id = res.paper_id
            that.setQuestionNos()
            that.selectQuestionIds = that.totalQuestionNos.slice(0, 10) //选中前10个题目id
            that.containerNum = res.single_choices.length + res.multi_choices.length + res.judge_list.length
            this.isTagActive()
            that.listQuestions().then(result => {
              screenScrollHandler('showFrame', 'exerciseWrap', that.loadedQuestions.length, that.screenWidth, that.switchQuestion)
            })

            that.userTags = res.user_tags
            //标签页title
            document.title = `做题-${ this.title }-未来网络学堂`;

            //reload 7moor js
            const s = document.createElement('script');
            s.type = 'text/JavaScript';
            s.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=a4c3d330-5dcc-11ea-b7ff-07dd5ece4b95&autoShow=true&language=ZHCN';
            document.body.appendChild(s);
          }
          else if(res.code == 1){
            this.goPath('/404')
          }
        })
      },
      delListById(id) {
        this.singleChoice = this.singleChoice.filter(item =>{
          return item.id !== id;
        })
        this.multipleChoice = this.multipleChoice.filter(item =>{
          return item.id !== id;
        })
        this.judgeChoice = this.judgeChoice.filter(item =>{
          return item.id !== id;
        })
      },
      delErrorListById(id) {
        this.errorSingleChoice = this.errorSingleChoice.filter(item =>{
          return item.id !== id;
        })
        this.errorMultipleChoice = this.errorMultipleChoice.filter(item =>{
          return item.id !== id;
        })
        this.errorJudgeChoice = this.errorJudgeChoice.filter(item =>{
          return item.id !== id;
        })
      },
      async listQuestions(index, isAnchor = false) { //index:0 向前加载，等于预加载的长度时为向后加载
        let filters = {
          paper_id: this.paper_id,
          need_answer: true,
          total: true
        }
        filters['question_ids'] = this.selectQuestionIds.join(',')
        if(this.activeName == 'wrong'){
          filters['is_right'] = false
        }

        const that = this
        if(this.loaded) { //loaded为true为全局加载层，即第一次进入或重新做题才显示，否则为局部加载
          this.partLoaded = false;
        }

        if(index == null || isAnchor) {
          that.loadedQuestions = []
          that.judgeChoice = []
          that.singleChoice = []
          that.multipleChoice = []
        }
        await listPapaerQuestion(this.paper_id, filters).then(res => {
          let loadedQuestionBack = [];

          res.true_false_list.forEach(item => {
            if(item.user_answer) {
              item.selected = item.user_answer.answer
            }
            if(index === 0) { //向前加载
              loadedQuestionBack.push(item)
            } else {
              that.loadedQuestions.push(item)
            }
          })
          res.single_choice_list.forEach(item => {
            if(item.user_answer) {
              item.selected = item.user_answer.answer
            }
            if(index === 0) {
              loadedQuestionBack.push(item)
            } else {
              that.loadedQuestions.push(item)
            }
          })
          res.multi_choice_list.forEach(item => {
            if(item.user_answer) {
              item.selected = item.user_answer.answer
            }
            if(index === 0) {
              loadedQuestionBack.push(item)
            } else {
              that.loadedQuestions.push(item)
            }
          })

          if(index === 0) {
              that.loadedQuestions = [...loadedQuestionBack, ...that.loadedQuestions]
          }

          let delNum = 0;

          if(that.loadedQuestions.length > 20) {  //判断预加载数量是否超过二十，超过，则删除多余项目
            delNum = that.loadedQuestions.length - 20;
            if(index !== 0) {  //向后加载
              for(let i=0; i< delNum; i++) {  //过滤掉已渲染出的超出项目
                const delId = that.loadedQuestions[i].id;
                that.delListById(delId)
              }

              that.loadedQuestions.splice(0, delNum)
            }

            if(index === 0) { //向前加载
              for(let i=1; i <= delNum; i++) {  //过滤掉已渲染出的超出项目
                const delId = that.loadedQuestions[that.loadedQuestions.length - i].id;
                that.delListById(delId)
              }

              that.loadedQuestions.splice(that.loadedQuestions.length - delNum, delNum)
            }
          }

          if(index === 0) { //向前加载
            that.singleChoice.unshift(...res.single_choice_list)
            that.multipleChoice.unshift(...res.multi_choice_list)
            that.judgeChoice.unshift(...res.true_false_list)
          } else {  //向后加载
            that.singleChoice.push(...res.single_choice_list)
            that.multipleChoice.push(...res.multi_choice_list)
            that.judgeChoice.push(...res.true_false_list)
          }

          let wrapDom = document.getElementById('exerciseWrap')
          wrapDom.itemNum = that.loadedQuestions.length
          if(index != null) {
            if(isAnchor) {  //是否是快速定位
              wrapDom.showIndex = index
            } else {
              if(this.selectQuestionIds.length < 10 && index === 0) {   //向前加载的项目不足10道
                wrapDom.showIndex = this.selectQuestionIds.length
              } else {
                wrapDom.showIndex = index !== 0 ? index - delNum : 10;
              }

            }

          } else {
            wrapDom.showIndex = 0
          }

          this.currentIndex = wrapDom.showIndex

          that.isNoTrans = true
          wrapDom.showFrameOffset = -(that.screenWidth * wrapDom.showIndex)
          wrapDom.style.left = `${wrapDom.showFrameOffset}px`

          // if(needResetPosition) { //渲染数据增减，需动态重定位
          //   that.isNoTrans = true
          //   wrapDom.showFrameOffset = -(that.screenWidth * wrapDom.showIndex)
          //   wrapDom.style.left = `${wrapDom.showFrameOffset}px`
          // }
          if(!that.loaded) {
            that.loaded = true;
          }
          that.partLoaded = true;
          if(that.isNoTrans) {
            setTimeout(() => {
              that.isNoTrans = false
            }, 400)
          }
        })
      },
      initErrorPage() {
        if(this.activeName == 'wrong'){
          const that = this
          let index = 0
          that.questionNos.errorSingleChoiceNos = {}
          that.questionNos.errorMultiChoiceNos = {}
          that.questionNos.errorJudgeNos = {}
          that.errorSingleChoiceObj = []
          that.errorMultiChoiceObj = []
          that.errorJudgeObj = []
          that.totalErrorQuestionNos = []

          that.judgeObj.forEach(item => {
            if(item.is_right === false){
              that.errorJudgeObj.push(item)
              that.totalErrorQuestionNos.push(item.id)
              that.questionNos.errorJudgeNos[item.id] = ++index
            }
          })
          index = 0
          that.singleChoiceObj.forEach(item => {
            if(item.is_right === false){
              that.errorSingleChoiceObj.push(item)
              that.totalErrorQuestionNos.push(item.id)
              that.questionNos.errorSingleChoiceNos[item.id] = ++index
            }
          })
          index = 0
          that.multiChoiceObj.forEach(item => {
            if(item.is_right === false){
              that.errorMultiChoiceObj.push(item)
              that.totalErrorQuestionNos.push(item.id)
              that.questionNos.errorMultiChoiceNos[item.id] = ++index
            }
          })
          that.loadedErrorQuestions = []
          that.errorJudgeChoice = []
          that.errorSingleChoice = []
          that.errorMultipleChoice = []
          that.errorContainerNum = that.totalErrorQuestionNos.length
          that.selectErrorQuestionIds = that.totalErrorQuestionNos.slice(0, 10)
          if(that.totalErrorQuestionNos.length !== 0) { //没有错题，不请求数据
            that.getErrorQuestions().then(result => {
              if(that.totalErrorQuestionNos.length > 0) {
                screenScrollHandler('errorShowFrame', 'errorExerciseWrap', that.loadedErrorQuestions.length, this.screenWidth, this.switchErrorQuestion)
              }
            })
          }
        }
        if(this.activeName == 'total'){
          const that = this
          that.partLoaded = false
          this.$nextTick(()=>{
            screenScrollHandler('showFrame', 'exerciseWrap', that.loadedQuestions.length, this.screenWidth, this.switchQuestion, this.currentIndex)
            this.anchorLinkTo(that.loadedQuestions[that.currentIndex].id)
          })
        }
        // this.isAlreadyLoadAllErrQuest = false
      },
      async getErrorQuestions(index, isAnchor = false) {
        let filters = {
          paper_id: this.paper_id,
          need_answer: true,
          is_right: false
        }
        filters['question_ids'] = this.selectErrorQuestionIds.join(',')

        const that = this

        this.partLoaded = false;

        if(index == null || isAnchor) {
          that.loadedErrorQuestions = []
          that.errorJudgeChoice = []
          that.errorSingleChoice = []
          that.errorMultipleChoice = []
        }

        await listPapaerQuestion(this.paper_id, filters).then(res => {
          // that.loaded = true

          let loadedErrorQuestionBack = [];

          res.true_false_list.forEach(item => {
            item.selected = item.user_answer.answer

            if(index === 0) { //向前加载
              loadedErrorQuestionBack.push(item)
            } else {
              that.loadedErrorQuestions.push(item)
            }
          })
          res.single_choice_list.forEach(item => {
            item.selected = item.user_answer.answer

            if(index === 0) { //向前加载
              loadedErrorQuestionBack.push(item)
            } else {
              that.loadedErrorQuestions.push(item)
            }
          })
          res.multi_choice_list.forEach(item => {
            item.selected = item.user_answer.answer

            if(index === 0) { //向前加载
              loadedErrorQuestionBack.push(item)
            } else {
              that.loadedErrorQuestions.push(item)
            }
          })

          if(index === 0) {
              that.loadedErrorQuestions = [...loadedErrorQuestionBack, ...that.loadedErrorQuestions]
          }

          let delNum = 0;
          // let needResetPosition = false;

          if(that.loadedErrorQuestions.length > 20) {  //判断预加载数量是否超过二十，超过，则删除多余项目
            delNum = that.loadedErrorQuestions.length - 20;
            if(index !== 0) {  //向后加载
              for(let i=0; i< delNum; i++) {  //过滤掉已渲染出的超出项目
                const delId = that.loadedErrorQuestions[i].id;
                that.delErrorListById(delId)
              }
              that.loadedErrorQuestions.splice(0, delNum)

            }

            if(index === 0) { //向前加载
              for(let i=1; i <= delNum; i++) {  //过滤掉已渲染出的超出项目
                const delId = that.loadedErrorQuestions[that.loadedErrorQuestions.length - i].id;
                that.delErrorListById(delId)
              }

              that.loadedErrorQuestions.splice(that.loadedErrorQuestions.length - delNum, delNum)
            }

          }
          if(index === 0) { //向前加载
            that.errorSingleChoice.unshift(...res.single_choice_list)
            that.errorMultipleChoice.unshift(...res.multi_choice_list)
            that.errorJudgeChoice.unshift(...res.true_false_list)
          } else {  //向后加载
            that.errorSingleChoice.push(...res.single_choice_list)
            that.errorMultipleChoice.push(...res.multi_choice_list)
            that.errorJudgeChoice.push(...res.true_false_list)
          }

          let wrapDom = document.getElementById('errorExerciseWrap')
          wrapDom.itemNum = that.loadedErrorQuestions.length
          if(index != null) {
            if(isAnchor) {  //是否是快速定位
              wrapDom.showIndex = index
            } else {
              if(this.selectErrorQuestionIds.length < 10 && index === 0) {   //向前加载的项目不足10道
                wrapDom.showIndex = this.selectErrorQuestionIds.length
              } else {
                wrapDom.showIndex = index !== 0 ? index - delNum : 10;
              }

            }

          } else {
            wrapDom.showIndex = 0
          }

          this.currentErrorIndex = wrapDom.showIndex

          that.isNoTrans = true
          wrapDom.showFrameOffset = -(that.screenWidth * wrapDom.showIndex)
          wrapDom.style.left = `${wrapDom.showFrameOffset}px`

          if(!that.partLoaded) {
            that.partLoaded = true
          }

          if(that.isNoTrans) {
            setTimeout(() => {
              that.isNoTrans = false
            }, 400)
          }



          // res.true_false_list.forEach(item => {
          //   item.selected = item.user_answer.answer
          //   that.loadedErrorQuestions.push(item)
          // })
          // res.single_choice_list.forEach(item => {
          //   item.selected = item.user_answer.answer
          //   that.loadedErrorQuestions.push(item)
          // })
          // res.multi_choice_list.forEach(item => {
          //   item.selected = item.user_answer.answer.split(',')
          //   that.loadedErrorQuestions.push(item)
          // })
          // that.errorJudgeChoice.push(...res.true_false_list)
          // that.errorSingleChoice.push(...res.single_choice_list)
          // that.errorMultipleChoice.push(...res.multi_choice_list)

        })
      },
      setQuestionNos() {
        const that = this
        that.totalQuestionNos = new Array()
        that.judgeObj.forEach((item, k) => {
          that.totalQuestionNos.push(item.id)
          that.questionNos.judgeNos[item.id] = k+1
        })
        that.singleChoiceObj.forEach((item, i) => {
          that.totalQuestionNos.push(item.id)
          that.questionNos.singleChoiceNos[item.id] = i+1
        })
        that.multiChoiceObj.forEach((item, j) => {
          that.totalQuestionNos.push(item.id)
          that.questionNos.multiChoiceNos[item.id] = j+1
        })
      },
      onSubmit(question){
        let is_right = false
        let answer = JSON.parse(question.answer).sort()
        let type = question.type_name
        let my_answer
        if(type == '单选题'){
          my_answer = question.selected
          if (my_answer === answer[0]){
            is_right = true
          }
        }
        else if (type == '多选题') {
          my_answer = question.selected.sort().join(',')
          if(my_answer == answer.join(',')){
            is_right = true
          }
        }
        else if(type == '判断题') {
          my_answer = question.selected
          if(question.selected == answer[0]){
            is_right = true
          }
        }

        let value = {
          paper_id: this.paper_id,
          question_id: question.id,
          // paper_question_id: question.paper_question_id,
          answer: my_answer,
          is_right: is_right
        }
        let data = {
          stem: question.text_stem,
          values: [value]
        }
        const that = this
        submitTest(data).then(res => {
          if(res.code == 0){
            question['user_answer'] = {
              is_right: is_right
            }
            if(type == '单选题'){
              that.singleChoiceObj.forEach(item => {
                if(item.id == question.id) {
                  item.is_right = is_right
                }
              })
            }
            else if(type == '多选题'){
              that.multiChoiceObj.forEach(item => {
                if(item.id == question.id) {
                  item.is_right = is_right
                }
              })
            }
            else if(type == '判断题'){
              that.judgeObj.forEach(item => {
                if(item.id == question.id) {
                  item.is_right = is_right
                }
              })
            }
          }
        })
      },
      goPath(path) {
        this.$router.push(path);
      },
      anchorLinkTo (id) {
        this.isNoTrans = true
        let index = this.totalQuestionNos.indexOf(id)

        if(index >= 10) {
          this.currentIndex = 10
          this.selectQuestionIds = this.totalQuestionNos.slice(index - 10, index + 10)
        } else {
          this.currentIndex = index
          if(index === 9) {
            this.selectQuestionIds = this.totalQuestionNos.slice(0, 20)
          } else {
            this.selectQuestionIds = this.totalQuestionNos.slice(0, 10)
          }
        }
        this.listQuestions(this.currentIndex, true)
        this.isShowList = false
      },
      anchorErrorLinkTo (id) {
        this.isNoTrans = true
        let index = this.totalErrorQuestionNos.indexOf(id)

        if(index >= 10) {
          this.currentErrorIndex = 10
          this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(index - 10, index + 10)
        } else {
          this.currentErrorIndex = index
          if(index === 9) {
            this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(0, 20)
          } else {
            this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(0, 10)
          }
        }
        this.getErrorQuestions(this.currentErrorIndex, true)
        this.isShowList = false
      },
      tagQuestion() {
        const that = this
        let question_id
        if(this.activeName == 'total'){
          question_id = that.loadedQuestions[that.currentIndex].id
        }
        else {
          question_id = that.totalErrorQuestionNos[that.currentErrorIndex]
        }
        let data = {
          paper_id: this.paper_id,
          question_id: question_id
        }
        addUserTag(data).then(res => {
          if(res.code == 0){
            let index = that.userTags.indexOf(question_id)
            if(index >= 0){
              that.userTags.splice(index, 1)
            }
            else {
              that.userTags.push(question_id)
            }
          }
        })
      },
      restart() {
        const that = this
        this.isNoTrans = true
        // this.isAlreadyLoadAllQuest = false
        clearPaperAnswer(that.paper_id).then(res => {
          if(res.code == 0){
            that.activeName = 'total'
            that.singleChoice = new Array()
            this.multipleChoice = new Array()
            this.judgeChoice = new Array()
            that.loadedQuestions = []
            that.currentIndex = 0
            that.getCur()
            // that.activeName = 'total'
          }
        })
      },
      switchQuestion(index) { //切换时，预加载前后的题目
        this.currentIndex = index

        if(index + 1 === this.loadedQuestions.length) { //如果滑动到预加载的最后一项，则加载后十道，并判断预加载是否超过二十道，若超过，则清除前面十道
          const lastId = this.loadedQuestions[index].id;
          const lastIdIndex = this.totalQuestionNos.indexOf(lastId)
          if(lastIdIndex + 1 !== this.totalQuestionNos.length) {
            this.selectQuestionIds = this.totalQuestionNos.slice(lastIdIndex + 1, lastIdIndex + 11);
            this.listQuestions(index)
          }
        }
        if(index === 0) { //如果滑动到预加载第一项，判断前面是否还有项目，若有，加载前面十道
          const firstId = this.loadedQuestions[index].id;
          const firstIdIndex = this.totalQuestionNos.indexOf(firstId)
          if(firstIdIndex !== 0) {
            if(firstIdIndex >= 10) {
              this.selectQuestionIds = this.totalQuestionNos.slice(firstIdIndex - 10, firstIdIndex);
            } else {
              this.selectQuestionIds = this.totalQuestionNos.slice(0, firstIdIndex);
            }
            this.listQuestions(index)
          }
        }
      },
      switchErrorQuestion(index) {
        this.currentErrorIndex = index

        if(index + 1 === this.loadedErrorQuestions.length) { //如果滑动到预加载的最后一项，则加载后十道，并判断预加载是否超过二十道，若超过，则清除前面十道
          const lastId = this.loadedErrorQuestions[index].id
          const lastIdIndex = this.totalErrorQuestionNos.indexOf(lastId)
          if(lastIdIndex + 1 !== this.totalErrorQuestionNos.length) {
            this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(lastIdIndex + 1, lastIdIndex + 11)
            this.getErrorQuestions(index)
          }
        }
        if(index === 0) { //如果滑动到预加载第一项，判断前面是否还有项目，若有，加载前面十道
          const firstId = this.loadedErrorQuestions[index].id;
          const firstIdIndex = this.totalErrorQuestionNos.indexOf(firstId)
          if(firstIdIndex !== 0) {
            if(firstIdIndex >= 10) {
              this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(firstIdIndex - 10, firstIdIndex);
            } else {
              this.selectErrorQuestionIds = this.totalErrorQuestionNos.slice(0, firstIdIndex);
            }
            this.getErrorQuestions(index)
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/css/ueditor.scss";
</style>
<style lang="scss" scoped>
  :deep(.exercise_tabs) {
    position:fixed;
    top:60px;
    width:100%;
    bottom:70px;
    display:flex;
    flex-direction: column;
    .van-tabs__content {
      flex:1;
      overflow-x:hidden;
      overflow-y:auto;
    }
  }
  dl.exercise {
    margin:0;
    dt {
      margin-bottom:15px;
      background:#f8f8f8;
      padding:10px;
    }
    dd {
      margin:0;
      ul {
        li {
          display:flex;
          line-height:1.5;
          color:#333;
          padding-bottom:10px;
          margin-bottom:15px;
          .no {
            width:40px;
            font-size:16px;
            margin-right:10px;
            text-align: center;
          }
          .content {
            flex: 1;
            :deep(.stem) {
              margin-bottom:10px;
              font-size:16px;
              p {
                margin-top:0;
                img {
                  max-width:100%;
                }
              }
            }
            :deep(.options) {
              .van-radio, .van-checkbox {
                align-items: start;
                margin-bottom: 15px;
              }
              .opts_wrap {
                display:flex;
                color:#666;
                .opts_no {
                  margin-right:5px;
                }
                .opts_content {
                  p {
                    margin:0;
                  }
                  img {
                    max-width:100%;
                  }
                }

              }
            }
          }
        }
      }
    }
  }
  .analysis {
    padding: 15px;
    font-size: 12px;
    background: #f8f8f8;
    .answer {
      > span {
        margin-right: 20px;

        > i {
          margin-right: 5px;
        }

        &.success {
          color: #6ecd3f;
        }

        &.error {
          color: #f51c21;
        }
      }
    }
    .tip {
      margin-top: 15px;
      .van-tag {
        margin-bottom: 10px;
      }
      > p {
        margin: 0;
      }
    }
  }
  .sheet_fixed_bottom {
    overflow:hidden;
    .top {
      display:flex;
      align-items: center;
      padding:15px;
      height:70px;
      border-bottom: 1px solid #ebedf0;
      .left, .right {
        flex: 1;
        > span {
          i, span {
            vertical-align: middle;
          }
          i {
            vertical-align: middle;
            color:#c1c1c1;
          }
        }
      }
      .left {
        > span {
         i {
           font-size:21px;
           margin-right:5px;
           &.active {
             color: var(--van-primary-color)
           }
         }
        }
      }
      .right {
        text-align:right;
        > span {
          i {
            font-size:18px;
            margin-right:10px;
          }
        }
      }
    }
    .bottom {
      position: absolute;
      top: 70px;
      right: 0;
      bottom: 0;
      left: 0;
      overflow-x: hidden;
      overflow-y: auto;
      .container {
        .title {
          margin-top:0;
          margin-bottom:15px;
          font-weight: normal;
          color:#333;
        }
        :deep(.index_list) {
          .van-col {
            padding-left:5px;
            padding-right:5px;
          }
        }
        .index {
          font-size:12px;
          color:#fff;
          background:#d1d1d1;
          border-radius: 2px;
          height:33px;
          line-height:33px;
          text-align:center;
          cursor: pointer;
          margin-bottom:15px;
          position:relative;
          overflow:hidden;
          > i {
            position:absolute;
            font-size:12px;
            right:1px;
            top:-2px;
            color:#009dd9;
            line-height:normal;
          }
          &.success, &.error {
            > i {
              color:#fff;
            }
          }
          &.success {
            background:#52c41a;
          }
          &.error {
            background:#f51c21;
          }

        }
      }
    }
    &.active {
      top:0;
    }
  }
  .show_frame {
    width:100%;
    position:absolute;
    top:44px;
    bottom:0;
    overflow:hidden;
    .exercise_wrap {
      position:absolute;
      left:0;
      top:0;
      height:100%;
      -webkit-transition: all .4s ease;
      transition: all .4s ease;
      .container {
        max-height:100%;
        overflow-x:hidden;
        overflow-y:auto;
        float:left;
      }
      &.no_trans {
        -webkit-transition: none;
        transition: none;
      }
    }
  }
  .help_wrap {
    text-align: center;
    .title {
      font-family: "font-fzmw";
      font-size:21px;
      color:#fff;
      margin-bottom:10px;
    }
    img {
      display:block;
      margin:0 auto 10px;
      &.arrow {
        width: 80%;
      }
      &.hand {
        width:60px;
        margin-bottom:40px;
        animation: handMove 4s infinite;
      }
    }
    button {
      background:transparent;
      padding:10px 30px;
      -webkit-box-shadow: none;
      box-shadow: none;
      border:2px solid #fff;
      border-radius:2px;
      color:#fff;
    }
  }

  :deep(.part_loading) {
    .van-overlay {
      position: fixed;
      top:104px;
      left:0;
      right:0;
      bottom:71px;
      height:auto;
    }
  }

  @keyframes handMove {
    0% {transform: translateX(0);}
    25% {transform: translateX(-100px);}
    50% {transform: translateX(0);}
    75% {transform: translateX(100px);}
    100% {transform: translateX(0);}
  }
</style>
